import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  ParkingManagementResponse,
  ParkingManagement,
  AddParkingManagementResponse,
} from '@core/interface/parking-managment';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ParkingManagementService {
  constructor(private http: HttpClient) {}

  getParkingManagement(data?: PagePayload) {
    const filter = { ...data };
    if (typeof filter?.customer_type !== 'undefined') {
      filter.type = filter.customer_type;
    }
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<ParkingManagementResponse>(
      environment.endPoints.parkingList,
      {
        params: httpParams,
      }
    );
  }

  addMarkAsPaidParkingManagement(data: ParkingManagement) {
    return this.http.post<AddParkingManagementResponse>(
      environment.endPoints.markAsPaidParkingAddEdit,
      data
    );
  }
}
